import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(val) {
      return {
        // 这个可以显示要缓存的数据
        page_toggle_index:val.page_toggle_index,
      }
    }
  })],
  state : {
    page_toggle_index:0,
    user_info:{},
    scenic_biz_id:'',
    token:''
  },
  mutations : {
    setPageToggle(state,n) {
      state.page_toggle_index = n
    },
    setUserInfo(state,n){
      state.user_info = n
    },
    setScenicId(state,n){
      state.scenic_biz_id = n
    },
    setToken(state,n){
      state.token = n
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js